// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + "shimport" + "." + "a56b01187b25890eed92" + ".js";
};